import React from 'react';
import Card from 'react-bootstrap/Card';
import { USCurrentStyleDecimal } from '../../utils';
import { getMinLoanRequired } from '../../utils/lenderUtils.ts';

function OptionOutputsBottom({ option, active }) {
  const lender = active.lender;
  const minLoanRequired = getMinLoanRequired(lender, option.financePlan);
  const isSplitLoanActive =
    option.splitLoan.isEnabled &&
    option.splitLoan.primaryLender.approvedAmount > 0;

  const milanRequiredDownPmt = option.splitLoan.secondaryLender.requiredDownPmt;

  return (
    <Card.Body
      className={`output position-relative pt-2 pb-0 px-0 ${
        option.items.length > 0 ? 'milan-bg-secondary' : ''
      } ${active.preSale ? 'milan-bg-primary-light' : ''}`}
    >
      {option.items.length > 0 && (
        <>
          <p className='milan-text-navy mb-1'>
            <span>Original Cost</span>
            <span className='float-end'>
              <span className='text-decoration-line-through milan-text-navy'>
                {USCurrentStyleDecimal(option.totalOriginalCost)}
              </span>
            </span>
          </p>
          {active.privateSale !== 'None' && (
            <p className='milan-text-navy mb-1'>
              <span>Private Sale</span>{' '}
              {option.privateSale !== 0 ? (
                <span className='float-end'>${option.privateSale}</span>
              ) : (
                <span className='float-end'>N/A</span>
              )}
            </p>
          )}
          <p className='mb-1 fw-bold'>
            <span> Discount Savings</span>{' '}
            <span className='float-end'>
              - {USCurrentStyleDecimal(option.totalSavings)}
            </span>
          </p>

          {option.fee > 0 && (
            <>
              <p className='mb-1'>
                <span>Cost After Discount Savings</span>{' '}
                <span className='float-end'>
                  {USCurrentStyleDecimal(option.costAfterSavings)}
                </span>
              </p>
              <p className='milan-text-navy mb-1'>
                <span>
                  {active.state.id === 'colorado'
                    ? 'Public Improvement Fee'
                    : 'Sales Tax'}
                </span>
                <span className='float-end'>
                  <span className='milan-text-navy'>
                    {USCurrentStyleDecimal(option.fee)}
                  </span>
                </span>
              </p>
            </>
          )}

          <p className='milan-text-tur fw-bold mb-1 fs-5 lh-sm milan-bg-light-tur'>
            <span>Your Cost</span>{' '}
            <span className='float-end'>
              {USCurrentStyleDecimal(option.finalTotalCost)}
            </span>
          </p>
          {option.todaysPayment > 0 && (
            <>
              {option.requiredDownPmt > 0 && !isSplitLoanActive && (
                <p className='milan-text-navy mb-1 d-flex justify-content-between'>
                  <small>Required Down Payment to Lender</small>
                  <span className='float-end'>
                    {USCurrentStyleDecimal(option.requiredDownPmt)}
                  </span>
                </p>
              )}

              {isSplitLoanActive && (
                <p className='milan-text-navy mb-1 d-flex justify-content-between'>
                  <small>Required Down Payment to Milan</small>{' '}
                  <span className='float-end'>
                    {USCurrentStyleDecimal(milanRequiredDownPmt)}
                  </span>
                </p>
              )}

              {option.additionalDownPmt > 0 && (
                <p className='milan-text-navy mb-1 d-flex justify-content-between'>
                  <small>Additional Down Payment to Milan</small>{' '}
                  <span className='float-end'>
                    {USCurrentStyleDecimal(option.additionalDownPmt)}
                  </span>
                </p>
              )}

              {option.displayedFinanced > 0 && (
                <p className='fw-bold mb-1 lh-sm'>
                  <span>Total Financed</span>{' '}
                  <span className='float-end'>
                    {USCurrentStyleDecimal(option.displayedFinanced)}
                  </span>
                </p>
              )}
            </>
          )}
          {minLoanRequired > 0 && option.totalFinanced < minLoanRequired && (
            <p className='mb-1 fine-print milan-text-red text-center print-hide'>{`A minimum of ${USCurrentStyleDecimal(
              minLoanRequired,
            )} total financed is required`}</p>
          )}
        </>
      )}
    </Card.Body>
  );
}

export default OptionOutputsBottom;
